<span
  class="fx-row fx-align-center hover-container"
  [additionalClasses]="additionalClasses"
  [ngxClickToCopy]="textToCopy"
  (copied)="copySuccess()"
  (mouseleave)="copyTooltip.hide()">
  <ng-content></ng-content>
  <mat-icon
    #copyTooltip="matTooltip"
    class="ml-1"
    [ngClass]="{
      'on-hover': hover,
      'text-green-400': isCopied,
      'text-grey-400': !isCopied
    }"
    [matTooltip]="isCopied ? copiedTooltip: tooltip"
    [matTooltipPosition]="position">
    {{ isCopied ? 'done' : 'content_copy' }}
  </mat-icon>
</span>
